export default "__VITE_ASSET__DfFOaRCQ__"